import { useContext, useEffect, useState, } from 'react';
import { JobSearchContext } from './context';

export const useClearFilters = () => {
  const {
    setIsRemote,
    setKeywordUserInput,
    setKeyword,
    setPublicationInterval,
    setType,
    setField,
    setOrder,
    setPageNumber,
    setLocations,
    setJobLevels,
    setNewsTopics,
    setPositionTypes,
    setOrgNames,
    setStages,
    setSearchSelected,
    setHasSalaryData,
  } = useContext(JobSearchContext);

  const clearFilters = () => {
    setIsRemote(undefined);
    setKeywordUserInput(undefined);
    setKeyword(undefined);
    setPublicationInterval(undefined);
    setType(undefined);
    setField(undefined);
    setOrder(undefined);
    setPageNumber(undefined);
    setLocations([]);
    setJobLevels([]);
    setNewsTopics([]);
    setPositionTypes([]);
    setOrgNames([]);
    setStages([]);
    setSearchSelected([]);
    setHasSalaryData(undefined);
  };

  return clearFilters;
};

export const useClearMobileFilters = () => {
  const {
    setIsRemote,
    setPublicationInterval,
    setType,
    setPageNumber,
    setLocations,
    setJobLevels,
    setNewsTopics,
    setPositionTypes,
    setOrgNames,
    setStages,
    setSearchSelected,
    setHasSalaryData,
  } = useContext(JobSearchContext);

  const clearFilters = () => {
    setIsRemote(undefined);
    setPublicationInterval(undefined);
    setType(undefined);
    setPageNumber(undefined);
    setLocations([]);
    setJobLevels([]);
    setNewsTopics([]);
    setPositionTypes([]);
    setOrgNames([]);
    setStages([]);
    setSearchSelected([]);
    setHasSalaryData(undefined);
  };

  return clearFilters;
};

export const useGetMobileFiltersCount = () => {
  const [count, setCount] = useState(0);

  const {
    isRemote,
    publicationInterval,
    type,
    locations,
    jobLevels,
    newsTopics,
    positionTypes,
    orgNames,
    stages,
    hasSalaryData,
  } = useContext(JobSearchContext);

  useEffect(() => {
    let localCount = 0;

    if (isRemote === 'true') localCount += 1;
    if (hasSalaryData === 'true') localCount += 1;
    if (type) localCount += 1;
    if (publicationInterval) localCount += 1;
    if (typeof locations !== 'undefined') localCount += 1;
    if (typeof jobLevels !== 'undefined') localCount += 1;
    if (typeof newsTopics !== 'undefined') localCount += 1;
    if (typeof positionTypes !== 'undefined') localCount += 1;
    if (typeof orgNames !== 'undefined') localCount += 1;
    if (typeof stages !== 'undefined') localCount += 1;

    setCount(localCount);
  }, [
    isRemote,
    publicationInterval,
    type,
    locations,
    jobLevels,
    newsTopics,
    positionTypes,
    orgNames,
    stages,
    hasSalaryData,
  ]);

  return count;
};

export const useScrollToResults = () => {
  const { scrollToElement, deviceInfo, } = useContext(JobSearchContext);

  return () => {
    if (scrollToElement.current && deviceInfo.isMobile) {
      scrollToElement.current.scrollIntoView({
        block: 'start', inline: 'nearest', behavior: 'smooth',
      });
    }
  };
};
